export function clone<Type>(object: Type): Type {
    var clone: Type = JSON.parse(JSON.stringify(object))
    return clone
}